<template>
  <template v-if="isVisible">
    <div
      v-tooltip="displayedTooltip ? { placement: 'top', title: () => displayedTooltip, customClass: 'tooltip-pre-line' } : false"
      class="current-time-line-hit"
      :class="{ 'has-hover-effect': !!zoneInfo?.for }"
      :style="{ left: position + '%' }"
    ></div>
    <div
      class="current-time-line"
      :style="{ left: position + '%' }"
    ></div>
  </template>
</template>

<script>
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { formatTime } from '~/utils/time_utils';

dayjs.extend(utc);
dayjs.extend(timezone);

const REFRESH_INTERVAL = 60 * 1000; // 1 minute

export default {
  name: 'InsightsCurrentTimeLine',
  props: {
    timeZone: {
      type: String,
      required: true,
    },
    tooltip: {
      type: [String, Boolean],
      default: false,
    },
    zoneInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      position: null,
      intervalId: null,
      now: null,
    };
  },
  computed: {
    isVisible() {
      return this.position !== null;
    },
    displayedTooltip() {
      if (!this.zoneInfo?.for || !this.now) {
        return this.tooltip;
      }

      // "11:30 am" -> "11:30am"; 24h formats have no space to drop.
      const time = formatTime(moment(this.now), { showSeconds: 'never', timezone: this.zoneInfo.for })?.replace(' ', '');

      return `Current time: ${time}\n(${this.zoneInfo.offset}) ${this.zoneInfo.display_name}`;
    },
  },
  watch: {
    timeZone() {
      this.updatePosition();
    },
  },
  mounted() {
    this.updatePosition();
    this.intervalId = setInterval(this.updatePosition, REFRESH_INTERVAL);
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
  methods: {
    updatePosition() {
      this.now = Date.now();

      const totalMinutes = 24 * 60;
      const now = dayjs(this.now).tz(this.timeZone);
      const minutesSinceStart = now.hour() * 60 + now.minute();
      const percent = (minutesSinceStart / totalMinutes) * 100;

      // Wrap around 100%
      this.position = Number((percent % 100).toFixed(2));
    },
  },
};
</script>
